import { render } from "./AIbar.vue?vue&type=template&id=8815e42e"
import script from "./AIbar.vue?vue&type=script&lang=js"
export * from "./AIbar.vue?vue&type=script&lang=js"

import "./AIbar.vue?vue&type=style&index=0&id=8815e42e&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__